import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=28d4fb44&scoped=true&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=28d4fb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4fb44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d4fb44')) {
      api.createRecord('28d4fb44', component.options)
    } else {
      api.reload('28d4fb44', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=28d4fb44&scoped=true&", function () {
      api.rerender('28d4fb44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/person/delivery.vue"
export default component.exports